// Shared FAQ content used by both FaqPage (full list) and LandingPage (highlights)
export const faqs = [
  {
    category: "Getting Started",
    questions: [
      {
        q: "How long does it take to form an LLC in Texas?",
        a: "If you file online through SOSDirect, processing typically takes 2-5 business days. Filing by mail takes longer. The entire process from start to finish (choosing a name, filing, getting an EIN, etc.) can be done in 1-2 weeks if you stay focused.",
      },
      {
        q: "Can I form a Texas LLC if I live in another state?",
        a: "Yes! You don't need to be a Texas resident to form an LLC there. However, you will need a registered agent with a physical address in Texas. Many people use professional registered agent services for this.",
      },
      {
        q: "Do I need a lawyer to form an LLC?",
        a: "No, you don't legally need a lawyer. The Texas LLC formation process is straightforward enough to do yourself using this guide. However, if your business has complex ownership structures or you're in a heavily regulated industry, consulting a lawyer can be worthwhile.",
      },
      {
        q: "Can I be my own registered agent?",
        a: "Yes, as long as you have a physical street address in Texas (no P.O. boxes) and are available during normal business hours to receive legal documents. Many business owners prefer a professional service for privacy and reliability.",
      },
    ],
  },
  {
    category: "Costs & Fees",
    questions: [
      {
        q: "How much does it cost to form a Texas LLC?",
        a: "The minimum cost is $300 for the state filing fee (Certificate of Formation). Beyond that, costs vary: a registered agent service runs $50-$150/year, and an Operating Agreement template can be free to $200 if professionally drafted. Total DIY cost is typically $300-$400.",
      },
      {
        q: "Are there ongoing annual fees?",
        a: "Texas doesn't charge an annual report fee like some states. However, you must file a Franchise Tax Report and Public Information Report (PIR) by May 15 each year. Most small businesses owe $0 in franchise tax, but the filing is still required.",
      },
      {
        q: "Is the $300 filing fee refundable if my LLC is rejected?",
        a: "No, the $300 filing fee is non-refundable. This is why it's important to double-check your LLC name availability and all form details before submitting. Common reasons for rejection include name conflicts and incomplete information.",
      },
      {
        q: "Do I need to pay for an EIN?",
        a: "No! The EIN (Employer Identification Number) is completely free when you apply directly through the IRS website. Be wary of third-party services that charge for this — it's always free from the IRS.",
      },
    ],
  },
  {
    category: "Taxes & Compliance",
    questions: [
      {
        q: "Does Texas have a state income tax for LLCs?",
        a: "Texas has no state personal income tax. However, it does have a franchise tax (also called a margin tax) that applies to most businesses. The good news: if your LLC's total revenue is below the threshold (currently $2.47 million), you'll owe $0 — but you still must file the report.",
      },
      {
        q: "What is the franchise tax and when is it due?",
        a: "The Texas franchise tax is a privilege tax for doing business in the state. It's based on your revenue, not profit. Reports are due May 15 each year. Most new/small LLCs owe nothing but must still file a 'No Tax Due' report.",
      },
      {
        q: "Do I need a sales tax permit?",
        a: "Only if you sell taxable goods or services in Texas. If you're selling physical products, most digital goods, or certain services, you'll need a sales tax permit from the Texas Comptroller. It's free to obtain.",
      },
      {
        q: "What happens if I miss the May 15 franchise tax deadline?",
        a: "If you fail to file, you'll receive penalty notices and eventually the Texas Comptroller can forfeit your LLC's right to do business. Reinstatement requires paying penalties and all outstanding reports. Set a calendar reminder — it's easy to forget!",
      },
    ],
  },
  {
    category: "Operations & Management",
    questions: [
      {
        q: "What's the difference between member-managed and manager-managed?",
        a: "In a member-managed LLC, all owners (members) participate in daily business decisions. In a manager-managed LLC, members appoint one or more managers to handle operations — useful when you have passive investors or many members.",
      },
      {
        q: "Do I really need an Operating Agreement for a single-member LLC?",
        a: "Technically Texas doesn't require one, but it's strongly recommended. An Operating Agreement reinforces the legal separation between you and your LLC, which is key to maintaining liability protection. Banks and partners may also request it.",
      },
      {
        q: "Can I change my LLC name later?",
        a: "Yes, you can amend your Certificate of Formation to change your LLC name by filing with the Texas Secretary of State. There's a filing fee involved. You can also use a DBA (Doing Business As) to operate under a different name without changing your legal LLC name.",
      },
      {
        q: "How do I maintain my LLC's liability protection?",
        a: "Keep your personal and business finances completely separate, maintain your registered agent, file all required reports on time, document major business decisions, and follow the procedures in your Operating Agreement. This is called 'maintaining the corporate veil.'",
      },
    ],
  },
];

// The 6 highest-conversion FAQs to surface on the public landing page.
export const landingHighlights = [
  faqs[0].questions[0], // How long
  faqs[1].questions[0], // How much
  faqs[0].questions[2], // Need a lawyer?
  faqs[1].questions[3], // Pay for EIN?
  faqs[2].questions[1], // Franchise tax
  faqs[3].questions[1], // Operating Agreement
];
